import React from "react";
import { connect } from "react-redux";
import { Layout, Table, Button, Space, Tooltip, Checkbox, Modal, Spin, Input, Col, Row } from "antd";
import {
  PlusOutlined,
  BarsOutlined,
  ExportOutlined,
  InfoCircleOutlined,
	EyeOutlined,
} from "@ant-design/icons";
import {
  FormatDate,
  Header,
  ColumnEmployeeStatus,
  BatchUpdate,
} from "components";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getAllUsers, getUserKycStatus, getUserStatement } from "services/user-service";
import { saveFileResume, formatDate, isBcerto } from "utils";
import { bindActionCreators } from "redux";
import * as balanceAction from "actions/balance-action";
import { MdStar as AdminIcon, MdManageAccounts as OperatorIcon } from "react-icons/md";
import * as authAction from "actions/auth-action";
import _, { set } from "lodash";
import moment from "moment";
import Search from "antd/es/input/Search";

const { Footer, Content } = Layout;

const mapStateToProps = (state) => ({
  login: state.authReducer.loginReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...authAction,
      ...balanceAction,
    },
    dispatch,
  );

const DataFetch = {
  data: [],
  loading: false,
};

const UserScreen = (props) => {
  const {
    login,
    loginCompanyAction,
    compact = false, //compact
    onEditCompact = () => {}, //compact
    refresh = false, //compact
    onLoadUsers = () => {}, //compact
    getCompanyBalanceAction,
  } = props;
  const navigate = useNavigate();
  const [data, setData] = React.useState(DataFetch);
  const [initialData, setInitialData] = React.useState(DataFetch);
  const [subRoutes, setSubRoutes] = React.useState([]);
  const [itensUpdateStatus, setItensUpdateStatus] = React.useState([]);
  const { benefit } = login.user.feature;
  const [pageParams, setPageParams] = useSearchParams();
  const [page, setPage] = React.useState(pageParams.get("page") ?? 1);
  const [total, setTotal] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [loadingStatements, setLoadingStatements] = React.useState({});
  const [search, setSearch] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const [getChildrenCompanies, setGetChildrenCompanies] = React.useState(
    pageParams.get("getChildrenCompanies") ? JSON.parse(pageParams.get("getChildrenCompanies")) : false
  );

  const load = async (filter = '', page = 1, pageSize = 10) => {
    setLoading(true);
		setLoadingStatements({});
    setPage(page);
    setPageSize(pageSize);
    if (login.company.benefitAccount) await getCompanyBalanceAction();
		const { users, total: totalUsers } = await getAllUsers({
			filter: filter,
			getChildrenCompanies: getChildrenCompanies,
			page: page,
			pageSize: pageSize,
		});
    setTotal(totalUsers);
    setData({ data: users });
    setLoading(false);

    if (compact) {
      onLoadUsers(users);
    }

  };

	const loadBalance = async (user) => {
		try {
			setLoadingStatements(prev => ({ ...prev, [user.id]: {
				loading: true,
				balance: 0,
			}}));
			const balance = await getUserStatement(user.id);
			user.balance = balance.balance;
			setLoadingStatements(prev => ({ ...prev, [user.id]: {
				loading: false,
				balance: balance.balance,
			}}));
		} catch (error) {
			setLoadingStatements(prev => ({ ...prev, [user.id]: {
				loading: false,
				balance: 0,
			}}));
		}

	}

  const formatBalance = (value) => {
    return (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  const onNew = () => {
    navigate(`/user/add`);
  };

  const onBatch = () => {
    navigate(`/user/batch`);
  };

  const onRidirectToBusinessEntity = () => {
    navigate(`/user/business/batch`);
  };

  const editUser = async (record, value) => {
    if (login.company.isMatriz && login.company.id !== record.company.id) {
      editChildrenCompanyUser(record, value);
    } else {
      compact ? onEditCompact(value) : navigate(`/user/${value}`);
    }
  };

  const editChildrenCompanyUser = async (record, value) => {
    Modal.confirm({
      width: 500,
      okText: "Continuar",
      cancelText: "Voltar",
      title: `Você será direcionado para a empresa "${
        record.company.name
      }" para editar ${record.userSex.code === "M" ? "o" : "a"} ${
        "participante"
      } "${record.name}".`,
      onOk: async () => {
        setTimeout(async () => {
          await loginCompanyAction(record.company.id);
          navigate(`/user/${value}`);
          window.location.reload();
        }, 1000);
      },
      onCancel: () => {
        console.log('Cancel');
      },
    });
  };

  const loadSubRoutes = () => {
    let routes = [];
    // if (login.company.master || login.user.admin) {
    //   routes = [
    //     { label: "Outros Gerentes", route: "/user/manager/others" },
    //     { label: "Gerente de Cartão", route: "/user/manager/card" },

    //     { label: "Gerente de Cadastro", route: "/user/manager/register" },
    //     { label: "Equipes", route: "/user/equip" },
    //   ];
    // }

    // if (benefit) {
    //   routes.push({
    //     label: "Gerente de Segmentações",
    //     route: "/user/benefit/manager",
    //   });
    // }

    // if (login.children.has && (login.company.master || login.user.admin)) {
    //   routes.push({
    //     label: "Administradores",
    //     route: "/user/parent/administrator",
    //   });
    // }
    setSubRoutes(routes);
  };

  const prepareFileResume = (users) => {
    let ws_data = [];
    users.forEach((d) => {
      let tmp = {
        Nome: d.name,
        Email: d.email,
        CPF: d.cpf || d.disabledCpf,
        Nascimento: d.birthday ? formatDate(d.birthday) : "",
        Telefone: d.phone,
        Sexo: d.userSex.code,
        ...((login.company.master || login.company.enableCode) && {
          Código: d.code,
        }),
        Rua: d.address ? d.address.address : "",
        Número: d.address ? d.address.number : "",
        Complemento: d.address ? d.address.complement : "",
        Bairro: d.address ? d.address.neighborhood : "",
        CEP: d.address ? d.address.zipcode : "",
        Cidade: d.address ? d.address.city : "",
        Estado: d.address ? d.address.state : "",
        "Nome da Mãe": d.mother,
        Administrador: d.userType.code == "U" ? "Sim" : "Não",
        Cartão: d.cardStatus.name,
        "Validação de Dados": d.validation ? d.validation.name : "",
        "Status de Carga": d.chargeStatus.name,
        Ativo: d.enabled ? "Sim" : "Não",
        Empresa: d.company.name,
      };
      if (login.company.master) {
        tmp["Tipo"] = d.companyExternal.companyType.name;
      }
      ws_data.push(tmp);
    });
    return ws_data;
  };

  const onExport = async () => {
    const { users } = await getAllUsers({ filter: '', getChildrenCompanies, page: null, pageSize: null });
    saveFileResume(prepareFileResume(users), "Participantes", "Participantes");
  };

  const validValue = (value) => {
    if (value === "" || value === null) {
      return (
        <Tooltip title={"Dado obrigatório não cadastrado!"}>
          <InfoCircleOutlined className="color-warning" />
        </Tooltip>
      );
    } else {
      return value;
    }
  };

  const blackTextCell = () => isBcerto ? ({ className: "participants-table-cell" }) : {};

  const setItensUpdate = (itens) => {
    let dataAux = [...data.data];
    for (let data of itens) {
      dataAux.filter((d) => d.id == data.id)[0] = data;
    }
    setData((x) => ({ ...x, data: dataAux }));
  };

  const statusFilters = [
    {
      text: "Ativo",
      value: "active",
      predicate: (record) => record.enabled === true,
    },
    {
      text: "Inativo",
      value: "inactive",
      predicate: (record) => record.enabled === false,
    },
    {
      text: "Erros de Biometria",
      value: "biometric_errors",
      predicate: (record) => (record.biometricStatusMessage?.length ?? 0) > 0,
    },
    {
      text: "Erros de KYC",
      value: "kyc_errors",
      predicate: (record) => (record.kycStatusMessage?.length ?? 0) > 0,
    },
  ];

  const performFilter = (value, record) => {
    const currentFilter = statusFilters.find(
      (element) => element.value === value,
    );
    return currentFilter ? currentFilter.predicate(record) : false;
  };

  React.useEffect(() => {
    loadSubRoutes();
  }, [login]);

  React.useEffect(() => {
    if (refresh) {
      load();
    }
  }, [refresh]);

  React.useEffect(() => {
     if (!login.company.master || (pageParams.get("page") && !pageParams.get("search"))) {
      load(search);
    }
    if (login.company.isMatriz) {
      setPageParams((p) => {
        p.set("getChildrenCompanies", getChildrenCompanies);
        p.delete("search")
        p.set("page", 1)
        return p;
      });
    }
  }, [getChildrenCompanies]);
  React.useEffect(() => {
    setPageParams((p) => {
      p.set("page", page);
      return p;
    });
  }, [page]);

  const table = (
    <React.Fragment>
      <BatchUpdate
        onChange={e => setItensUpdate(e)}
        onChangeItem={e => (e.onRequest = false)}
        start={itensUpdateStatus}
        filter={e => e.validation && e.validation.onRequest}
        data={itensUpdateStatus}
        request={getUserKycStatus}
        fieldKey="id"
        fieldResponse="validation"
      />
      {!compact && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            padding:"16px"
          }}
        >
          <Row
            style={{ display: "flex", justifyContent: "flex-end", alignItems: 'center' }}
            justify={"end"} gutter={[12, 12]}
          >
            <Col xl={8} lg={12} md={24}>
              <Search
                placeholder="Pesquise por nome, cpf ou email..."
                value={search}
                onChange={async (e) => {
                  setSearch(e.target.value);
                }}
                onPressEnter={async () => {
                  if(search.trim().length > 0) {
                    await load(search)
                  }
                }}
                onSearch={async () => {
                  if(search.trim().length > 0) {
                    await load(search)
                  }
                }}
              />
            </Col>
            <Col xl={3} lg={8} md={24}>
              <Button
                type="primary"
                style={{ width: "100%" }}
                onClick={async () => {
                  setPageParams({ page: 1 });
                  setSearch("");
                  await load("");
                }}
              >
                Carregar Todos
              </Button>
            </Col>
          </Row>
          {login.company.isMatriz && (
            <Checkbox
              checked={getChildrenCompanies}
              style={{ alignSelf: "flex-end" }}
              onChange={() => {
                setGetChildrenCompanies(!getChildrenCompanies);
              }}
            >
              Buscar em filial
            </Checkbox>
          )}
        </div>
      )}
      <Table
        className="participants-table"
        scroll={{ y: 650, x: 1000 }}
        dataSource={data.data}
        onChange={page => {
          setPage(page.current);
        }}
        loading={loading}
        pagination={{
          current: pageParams.get("page"),
          total: total,
          pageSize: pageSize,
          onChange: async (page, pageSize) => {
            setPage(page);
            setPageSize(pageSize);
            await load(search, page, pageSize)
            setItensUpdateStatus(data.data.slice((page - 1) * pageSize, page * pageSize))
          }
        }}
        bordered
      >
        {login.company.multicompany && (
          <React.Fragment>
            <Table.Column
              width={350}
              title="Empresa"
              dataIndex={["companyExternal", "name"]}
              key="companyExternal.name"
              onCell={blackTextCell}
            />
            <Table.Column
              width={150}
              align="center"
              title="Tipo"
              dataIndex={["companyExternal", "companyType", "name"]}
              key="companyExternal.companyType.name"
              filters={_.uniqWith(
                data.data.map(d => {
                  return {
                    text: d.companyExternal.companyType.name,
                    value: d.companyExternal.companyType.code
                  };
                }),
                _.isEqual
              )}
              onFilter={(value, record) => record.companyExternal.companyType.code === value}
              onCell={blackTextCell}
            />
          </React.Fragment>
        )}
        <Table.Column
          width={350}
          title="Nome"
          dataIndex="name"
          key="name"
          onCell={blackTextCell}
          render={(value, record) => (
            <Space>
              {validValue(value)}
              {record.userType.code === "U" && (
                <Tooltip title="Administrador">
                  <AdminIcon color="#faad14" />
                </Tooltip>
              )}
              {record.userType.code === "O" &&(
                <Tooltip title="Operador">
                  <OperatorIcon/>
                </Tooltip>
              )}
              {record.userType.code === "C" &&(
                <Tooltip title="Operador de Empresas">
                  <OperatorIcon color="#1677ff"/>
                </Tooltip>
              )}
              {moment().diff(record.birthday, "years") < 18 &&
                (record.mother === null || record.mother === "") && (
                <Tooltip title="Participante menor de idade sem nome da mãe cadastrado.">
                    <InfoCircleOutlined className="color-warning" />
                  </Tooltip>
                )}
            </Space>
          )}
        />
        <Table.Column
          width={350}
          title="Email"
          dataIndex="email"
          key="email"
          onCell={blackTextCell}
          render={value => validValue(value)}
        />
        <Table.Column
          width={150}
          align="center"
          title="CPF"
          dataIndex="cpf"
          key="cpf"
          render={(value, row) => validValue(value || row.disabledCpf)}
        />
        <Table.Column
          width={150}
          align="center"
          title="Nascimento"
          dataIndex="birthday"
          key="birthday"
          render={value => (value ? validValue(<FormatDate value={value} />) : validValue(value))}
        />
        <Table.Column
          width={70}
          align="center"
          title="Sexo"
          dataIndex={["userSex", "code"]}
          key="userSex.code"
          render={value => validValue(value)}
        />
        <Table.Column width={150} align="center" title="Razão Social" dataIndex="businessName" key="businessName" />
        <Table.Column width={150} align="center" title="CNPJ" dataIndex="cnpj" key="cnpj" render={(value, row) => value || row.disabledCnpj} />
        <Table.Column width={150} align="center" title="Telefone" dataIndex="phone" key="phone" />
        <Table.Column width={150} align="center" title="Unidade de Negócio" dataIndex="businessUnit" key="businessUnit" />
        <Table.Column width={150} align="center" title="Região" dataIndex="region" key="region" />
        <Table.Column width={150} align="center" title="Diretoria" dataIndex="directorship" key="directorship" />
        <Table.Column width={150} align="center" title="Cargo" dataIndex="occupation_name" key="occupation_name" />
        <Table.Column width={150} align="center" title="Campanha" dataIndex="campaign" key="campaign" />
        {login.company.enableCode && (
          <Table.Column width={120} title="Código" dataIndex="code" key="code" />
        )}
        <Table.Column
          width={150}
          align="center"
          title="Saldo"
          dataIndex="balance"
          key="balance"
          fixed="right"
          onCell={blackTextCell}
					render={(value, row) => (
						loadingStatements[row.id] ?
							loadingStatements[row.id].loading ? <Spin /> : formatBalance(loadingStatements[row.id].balance || 0)
							: <EyeOutlined onClick={() => loadBalance(row)} />
					)}

        />
        <Table.Column
          width={180}
          fixed="right"
          align="center"
          title="Status"
          key="status"
          filters={statusFilters}
          onFilter={performFilter}
          onCell={blackTextCell}
          render={value => <ColumnEmployeeStatus data={value} />}
        />
        {!compact && (
          <Table.Column
            fixed="right"
            width={80}
            align="center"
            title="Ações"
            dataIndex="id"
            key="id"
            onCell={blackTextCell}
            render={(value, row) => (
              <Button
                size="small"
                type={"link"}
                loading={login.isProcessing}
                onClick={() => editUser(row, value)}
              >
                Editar
              </Button>
            )}
          />
        )}
      </Table>
    </React.Fragment>
  );

  return compact ? (
    table
  ) : (
    <Layout className="alymente-layout">
      {!compact && <Header title="Cadastro de Participantes" routes={subRoutes} />}
      <Content style={compact ? { paddingRight: 8, paddingLeft: 8 } : {}}>
        {table}
      </Content>
      {!compact && (
        <Footer>
          <Space align="end">
            {(login.company.master || login.user.admin) && (
              <Button
                type="primary"
                icon={<ExportOutlined />}
                onClick={onExport}
              >
                Exportar
              </Button>
            )}
            <Button type="primary" icon={<BarsOutlined />} onClick={onRidirectToBusinessEntity}>
							Lote Pessoa Jurídica
            </Button>
            <Button type="primary" icon={<BarsOutlined />} onClick={onBatch}>
							Lote Pessoa Física
            </Button>
            <Button type="primary" icon={<PlusOutlined />} onClick={onNew}>
							Cadastro Individual
            </Button>
          </Space>
        </Footer>
      )}
    </Layout>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserScreen);
